var _radialGradient, _path, _linearGradient, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _linearGradient5, _path6, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraftSewing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "2YxAnRwuhIPNpWhCyJfLqa",
    cx: 32,
    cy: 32,
    r: 33.002,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4e09d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#f8e8b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#fcf0cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#fef4dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6e1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2YxAnRwuhIPNpWhCyJfLqa)",
    d: "M55.454,45.668c0.5,0.898-5.496,1.337-4.468,1.332c1.75-0.008,3.153,1.483,3.002,3.262 C53.855,51.838,52.434,53,50.852,53L48,53v1H26h-8H7c-1.71,0-3.086-1.431-2.996-3.161C4.089,49.216,5.545,48,7.17,48L8,48 c1.215,0,2.176-1.083,1.973-2.336C9.813,44.681,8.889,44,7.893,44L3,44c-1.71,0-3.086-1.431-2.996-3.161 C0.089,39.216,1.545,38,3.17,38l6.33,0c1.381,0,2.5-1.119,2.5-2.5v0c0-1.381-1.119-2.5-2.5-2.5h0C8.119,33,7,31.881,7,30.5v0 C7,29.119,8.119,28,9.5,28H18v-7h-7.5c-1.995,0-3.601-1.67-3.495-3.688C7.104,15.419,8.803,14,10.698,14L18,14v-4h24h6h8.5 c1.995,0,3.601,1.67,3.495,3.688C59.896,15.581,58.197,17,56.302,17L53.5,17c-1.995,0-3.601,1.67-3.495,3.688 C50.104,22.581,51.803,24,53.698,24L56,24c1.777,0,3.194,1.546,2.978,3.366c-0.179,1.509-1.546,2.572-3.064,2.635 c-1.197,0.05-2.122,1.153-1.874,2.406C54.228,33.355,55.123,34,56.089,34H60.5c1.995,0,3.601,1.67,3.495,3.688 C63.896,39.581,62.197,41,60.302,41L58,41C55.808,41,54.166,43.35,55.454,45.668z M2.5,33L2.5,33C3.881,33,5,31.881,5,30.5v0 C5,29.119,3.881,28,2.5,28h0C1.119,28,0,29.119,0,30.5v0C0,31.881,1.119,33,2.5,33z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "2YxAnRwuhIPNpWhCyJfLqb",
    x1: 33,
    x2: 33,
    y1: 58,
    y2: 6,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41bfec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#4cc5ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#6bd4f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89e4fd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2YxAnRwuhIPNpWhCyJfLqb)",
    d: "M47.532,58H16c-1.657,0-3-1.343-3-3V9c0-1.657,1.343-3,3-3h20.757 c0.796,0,1.559,0.316,2.121,0.879l13.243,13.243C52.684,20.684,53,21.447,53,22.243v30.289C53,55.552,50.552,58,47.532,58z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "2YxAnRwuhIPNpWhCyJfLqc",
    x1: 38.879,
    x2: 46.454,
    y1: 20.121,
    y2: 12.546,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7effd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#b8ecfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95e5fd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2YxAnRwuhIPNpWhCyJfLqc)",
    d: "M52.121,20.122L38.878,6.879c-0.255-0.255-0.556-0.452-0.878-0.6V18c0,1.657,1.343,3,3,3 h11.721C52.574,20.678,52.377,20.377,52.121,20.122z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "2YxAnRwuhIPNpWhCyJfLqd",
    x1: 45.5,
    x2: 45.5,
    y1: 24.083,
    y2: 18.083,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42c6ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#3bc3ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31bfeb"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2YxAnRwuhIPNpWhCyJfLqd)",
    d: "M41,21c-1.657,0-3-1.343-3-3v3c0,1.657,1.343,3,3,3h12v-1.757 c0-0.434-0.102-0.855-0.279-1.243H41z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "2YxAnRwuhIPNpWhCyJfLqe",
    x1: 22,
    x2: 22,
    y1: 19.605,
    y2: 6.12,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#81ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#8de1f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ee8fd"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2YxAnRwuhIPNpWhCyJfLqe)",
    d: "M21.5,21H13V9c0-1.657,1.343-3,3-3h9.5C26.881,6,28,7.119,28,8.5v0 c0,1.381-1.119,2.5-2.5,2.5h-5c-1.381,0-2.5,1.119-2.5,2.5v0c0,1.381,1.119,2.5,2.5,2.5h1c1.381,0,2.5,1.119,2.5,2.5v0 C24,19.881,22.881,21,21.5,21z M29,17c-1.105,0-2,0.895-2,2s0.895,2,2,2c1.105,0,2-0.895,2-2S30.105,17,29,17z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "2YxAnRwuhIPNpWhCyJfLqf",
    x1: 39.5,
    x2: 39.5,
    y1: 34.236,
    y2: 59.269,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#50c8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#3bbbea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33b5e8"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2YxAnRwuhIPNpWhCyJfLqf)",
    d: "M40,41l13,0v11.532C53,55.552,50.552,58,47.532,58H29c-1.657,0-3-1.343-3-3v0 c0-1.657,1.343-3,3-3l11.5,0c1.381,0,2.5-1.119,2.5-2.5v0c0-1.381-1.119-2.5-2.5-2.5H40c-1.657,0-3-1.343-3-3v0 C37,42.343,38.343,41,40,41z M32,41c-1.657,0-3,1.343-3,3s1.343,3,3,3c1.657,0,3-1.343,3-3S33.657,41,32,41z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "2YxAnRwuhIPNpWhCyJfLqg",
    x1: 60.036,
    x2: 60.036,
    y1: 65.032,
    y2: 55.019,
    gradientTransform: "rotate(-90 51.5 51.5)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff634d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#fd6464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#fc6582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#fa6694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#fa669a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa669a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#2YxAnRwuhIPNpWhCyJfLqg)",
    d: "M63.577,43.134l-3.711-3.709c-0.564-0.566-1.482-0.566-2.046,0l-1.747,1.747l5.758,5.757 l1.746-1.747C64.141,44.615,64.141,43.7,63.577,43.134"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2YxAnRwuhIPNpWhCyJfLqh",
    x1: 49.941,
    x2: 49.941,
    y1: 58.759,
    y2: 42.266,
    gradientTransform: "rotate(-90 51.5 51.5)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb65b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb65b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#2YxAnRwuhIPNpWhCyJfLqh)",
    d: "M46.694 62.066L40.937 56.309 53.193 44.053 58.95 49.81z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2YxAnRwuhIPNpWhCyJfLqi",
    x1: 57.507,
    x2: 57.507,
    y1: 50.958,
    y2: 59.595,
    gradientTransform: "rotate(-90 51.5 51.5)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3c3c3"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#2YxAnRwuhIPNpWhCyJfLqi)",
    d: "M58.953 49.811L53.193 44.054 56.071 41.175 61.831 46.931z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2YxAnRwuhIPNpWhCyJfLqj",
    x1: 42.848,
    x2: 42.848,
    y1: 54.262,
    y2: 39.317,
    gradientTransform: "rotate(-90 51.5 51.5)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#ffce76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#ffcd92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcca0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcca0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#2YxAnRwuhIPNpWhCyJfLqj)",
    d: "M40.938 56.305L39 64 46.695 62.063z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2YxAnRwuhIPNpWhCyJfLqk",
    x1: 40.945,
    x2: 40.945,
    y1: 38.197,
    y2: 42.087,
    gradientTransform: "rotate(-90 51.5 51.5)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6f6f6f"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#2YxAnRwuhIPNpWhCyJfLqk)",
    d: "M39.979 60.11L39 64 42.89 63.021z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftSewing);
export default __webpack_public_path__ + "static/media/Draft_sewing.c7652a532a0cab8831933af43011ef39.svg";
export { ForwardRef as ReactComponent };